import { BaseResponse } from "src/models/BaseModel";
import { PrivateApi } from "./BaseApi";

export const syncApi = PrivateApi.injectEndpoints({
  endpoints: (builder) => ({
    syncDaleelStore: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/SyncDaleelStore",
        method: "POST",
      }),
    }),
    syncPopularOffers: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/SyncPopularOffers",
        method: "POST",
      }),
    }),
    syncCouponz: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/SyncCouponz",
        method: "POST",
      }),
    }),
    SyncBlu: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/SyncBlu",
        method: "POST",
      }),
    }),
    syncRecurringJobs: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/SyncRecurringJobs",
        method: "POST",
      }),
    }),
    syncRewardCatalog: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/SyncRewardCatalog",
        method: "POST",
      }),
    }),
    ClearCache: builder.mutation<BaseResponse<Boolean>, void>({
      query: () => ({
        url: "Sync/ClearCache",
        method: "POST",
        body: {
          data: {
            tag: "*",
          },
        },
      }),
    }),
  }),
});

export const {
  useSyncDaleelStoreMutation,
  useSyncPopularOffersMutation,
  useSyncCouponzMutation,
  useSyncBluMutation,
  useSyncRecurringJobsMutation,
  useSyncRewardCatalogMutation,
  useClearCacheMutation,
} = syncApi;
